export default {
  "homeScreen": {
    "farm": "Farm",
    "label": "Select Farm",
    "noFarm": "No farm",

    "fetchingData": "Fetching data...",
    "pleaseWait": "Please wait",
    "noConnection": "Unable to display results.\nPlease check your connection and refresh the page.",

    "emptyFarm": "You don't have any farm yet",
    "emptyPond": "You don't have any pond yet",
    "emptyCycle": "You don't have any active cycle yet",
    "createFarm": "Create farm",
    "createPond": "Add pond",
    "createCycle": "Start cycle",

    "predictionBiomass": "Biomass Estimation",
    "actualFeedAccumulation": "Feed Total",
    "predictionSR": "SR Estimation",
    "predictionPrice": "Sell Price",
    "predictionWeight": "MBW Estimation",
    "from": "from ",
    "activePonds": " active ponds",

    "disclaimer": "Estimation are not accurate. Complete feed data to improve estimation accuracy",

    "monitoring": "Monitoring",
    "pond": "Ponds",
    "finance": "Finance",
    "price": "Price",
    "news": "News",
    "disease": "Diseases",
    "asto": "Asto",
    "predictions": "Predictions",
    "beta": "Beta",
    "autoFeeder": "Auto Feeder",
    "shrimpPrice": "Shrimp Price",
    "appMenusTitle": "Try More Features",
    "seeAll": "Show All",
    "shrimpNews": "Shrimp News",
    "consultTitle": "Need to consult?",
    "consultSubtitle": "Now you can consult about farming through the app.",
    "consultButton": "Ask Now",
    "youtubeTutorial": "Watch JALA App tutorial",
    "helpTutorial": "Help Centre",
    "telegramTutorial": "Join our Telegram Group",
    "bannerTitle": "Other Shrimp Farming Solutions",
    "bottomTitle": "Farming tutorial with JALA App",
    "overview": "Overview",
    "partner": "JALA Partner",
    "firstTooltip": "See predictions from the results of the data input that you do",
    "secondTooltip": "Manage shrimp farming with this menu",
    "thirdTooltip": "See predictions from the results of the data input that you do",
    "fourthTooltip": "Get the latest shrimp price information here",
    "fifthTooltip": "Latest shrimp news information here",
    "tooltipSkip": "Skip",
    "tooltipNext": "Next",
    "tooltipPrevious": "Previous",
    "notifications": "Notifications",
    "simulation": "Simulation",
    "chemicalPredictions": "Chemical Predictions",
    "predictions": "Predictions",
    "newLabel": "New",
    "activity": "To Do",

    "startCultivationTitle": "Manage your shrimp farm with Jala",
    "startCultivation": "Start Farming",

    "alertNoFarmTitle": "You need to have Farm",
    "alertNoFarmDescription": "Quick Input could be accessed if you already have a farm.",
    "alertNoActiveCycleTitle": "There's no active cycle",
    "alertNoActiveCycleDescription": "Start a cycle to input record.",
    "alertStartCultivationTitle": "Change to farming mode",
    "alertStartCultivationDescription": "To access the cultivation features, change the setting on: Account - Help - Display Personalization - then select Manage Cultivation.",

    "reminderActivity": "Press to complete your to do",
    "pro": "Pro",

    "occupationModalTitle": "Hello {{user}}!",
    "occupationModalSubtitle": "Complete your profile data to get better experience with JALA App",

    "offline": "Offline Mode"
  },

  "modelCreateScreen": {
    "areYouSure": "Are you sure?",
    "areYouSureYouWantToSomething": "Are you sure you want to %{something}?",

    "deleteSomething": "delete %{something}",
    "thisData": "this data"
  },

  "farmCreateScreen": {
    "title": "Create Farm",

    "disconnectedModalTitle": "You Are Not Connected",
    "disconnectedModalSubtitle": "The application has detected a weak connection, please ensure that you are connected to the Internet"
  },
  "farmEditScreen": {
    "title": "Farm Settings",
  },

  "pondCreateMultipleScreen": {
    "title": "Create Pond"
  },

  "cycleCreateMultipleScreen": {
    "title": "Start Cycle",

    "deleteCycle": "Delete Cycle",
    "deleteCycleSubtitle": "You couldn't access the deleted cycle",
    "deleteCycleModalTitle": "Are You Sure?",
    "deleteCycleModalSubtitle": "You will not be able to access your deleted cycles.",
  },

  "farmShrimpPriceCreateScreen": {
    "title": "Selling Price Settings",
  },

  "overviewScreen": {
    "setting": "Settings",
    "total": "Total",
    "average": "Average",
    "fromActivePonds": "from %{count} active ponds",
    "disclaimer": "Complete feed data to improve estimation accuracy."
  },
  "overviewTotalWeightPredictionListScreen": {
    "title": "Biomass Estimation",
  },
  "overviewHarvestAccumulationWeightActualListScreen": {
    "title": "Total Harvest",
  },
  "overviewFeedAccumulationActualListScreen": {
    "title": "Total Feed",
  },
  "overviewSurvivalRatePredictionListScreen": {
    "title": "SR Estimation",
  },
  "overviewSellingPricePredictionListScreen": {
    "title": "Selling Price Estimation",
    "source": "Selling price source: "
  },

  "shrimpPriceScreen": {
    "listShrimpPrice": "Shrimp Price List",
    "size": "Count",
    "close": "Close",
    "country": "Country",
    "location": "Location",
    "update": "Price Update",
    "all": "All",
    "verified": "Verified",
    "unverified": "Unverified",
    "supplier": "Supplier",
    "findLoc": "Find Location",
    "cancel": "Cancel",
    "latest": "Newest",
    "week": "> 1 Week",
    "month": "> 1 Month",
    "createPrice": "Create Shrimp Price",
    "name": "Your Name",
    "phone": "Phone Number",
    "species": "Species",
    "province": "Province",
    "city": "City or district",
    "next": "Next",
    "save": "Save",
    "shrimpPriceList": "Shrimp Price List",
    "createdAt": "Date",
    "date": "Date",
    "currency": "Currency",
    "currencyId": "Currency",
    "sizeInput": "Size Price",
    "remark": "Notes (optional)",
    "disclaimer": "I hereby take responsibility for the shrimp price information that I make and publish on Jala",
    "size200": "Count 200",
    "size190": "Count 190",
    "size180": "Count 180",
    "size170": "Count 170",
    "size160": "Count 160",
    "size150": "Count 150",
    "size140": "Count 140",
    "size130": "Count 130",
    "size120": "Count 120",
    "size110": "Count 110",
    "size100": "Count 100",
    "size90": "Count 90",
    "size80": "Count 80",
    "size70": "Count 70",
    "size60": "Count 60",
    "size50": "Count 50",
    "size40": "Count 40",
    "size30": "Count 30",
    "size20": "Count 20",
    "size150Placeholder": "Input price",
    "size140Placeholder": "Input price",
    "size130Placeholder": "Input price",
    "size120Placeholder": "Input price",
    "size110Placeholder": "Input price",
    "size100Placeholder": "Input price",
    "size90Placeholder": "Input price",
    "size80Placeholder": "Input price",
    "size70Placeholder": "Input price",
    "size60Placeholder": "Input price",
    "size50Placeholder": "Input price",
    "size40Placeholder": "Input price",
    "size30Placeholder": "Input price",
    "size20Placeholder": "Input price",

    "datePlaceholder": "Choose Date",
    "remarkPlaceholder": "Example : BS Price 60 % from normal price",
    "currencyPlaceholder": "Choose...",
    "currencyIdPlaceholder": "Choose...",
    "namePlaceholder": "Your Name",
    "phonePlaceholder": "Phone Number",
    "speciesPlaceholder": "Choose...",
    "countryPlaceholder": "Choose...",
    "provincePlaceholder": "Choose...",
    "provinceLabel": "Choose Province",
    "cityPlaceholder": "Choose...",
    "sizePlaceholder": "Nominal",
    "partner": "JALA Partner",
    "priceList": "Price List",
    "contact": "Contact",
    "seeContact": "Contact",
    "anotherPrice": "Prices in other regions",
    "implement": "Implement",

    "dateValidation": "Date must be filled",
    "currencyValidation": "Currency must be filled",
    "sizeValidation": "Size 100 must be filled",
    "phoneValidationLength": "Phone format is invalid",
    "selectAll": "SELECT ALL"
  },
  "shrimpPriceListScreen": {
    "title": "Shrimp Price",

    "listShrimpPrice": "Shrimp Price List",
    "createPrice": "Make a price",
    "partner": "JALA Partner",
    "listEmptyTitle": "Shrimp prices in the location you are looking for can't be found.",
    "listEmptySubtitle": "Try to find other locations to find shrimp prices.",
    "searchLocation": "Find Location",
  },
  "shrimpPriceDetailScreen": {
    "title": "Shrimp Price",

    "unverified": "Unverified",
    "verified": "Verified",
    "partner": "JALA Partner",

    "contact": "Contact",
    "seeContact": "Call",

    "priceList": "Price List",
    "anotherPrice": "Prices in other regions",
  },

  "waterQualityMultiMeasurementCreateScreen": {
    "title": "Add Water Quality Data"
  },
  "waterQualityMultiMeasurementEditScreen": {
    "title": "Edit Water Quality Data"
  },
  "feedCreateScreen": {
    "title": "Add Feed Data"
  },
  "feedEditScreen": {
    "title": "Edit Feed Data"
  },
  "feedingTrayControlCreateScreen": {
    "title": "Add Feeding Tray Data"
  },
  "feedingTrayControlEditScreen": {
    "title": "Edit Feeding Tray Data"
  },
  "mortalityCreateScreen": {
    "title": "Add Mortality Data"
  },
  "mortalityEditScreen": {
    "title": "Edit Mortality Data"
  },
  "chemicalMultiMeasurementCreateScreen": {
    "title": "Add Chemical Data"
  },
  "chemicalMultiMeasurementEditScreen": {
    "title": "Edit Chemical Data"
  },
  "planktonMultiMeasurementCreateScreen": {
    "title": "Add Plankton Data"
  },
  "planktonMultiMeasurementEditScreen": {
    "title": "Edit Plankton Data"
  },
  "microbiologyMultiMeasurementCreateScreen": {
    "title": "Add Microbiology Data"
  },
  "microbiologyMultiMeasurementEditScreen": {
    "title": "Edit Microbiology Data"
  },
  "cycleDiseaseListScreen": {
    "seeRelatedDiseaseInfo": "See Related Disease Info"
  },
  "cycleDiseaseCreateScreen": {
    "title": "Add Data",
    "seeDiseaseInfo": "See Disease Info"
  },
  "cycleDiseaseEditScreen": {
    "title": "Edit Data",
    "seeDiseaseInfo": "See Disease Info"
  },
  "cycleEditScreen": {
    "title": "Edit Cycle Data"
  },

  "cycleHarvestListScreen": {
    "closeCycle": "Close Cycle"
  },

  "cycleCloseScreen": {
    "title": "Close Cycle"
  },
  "cycleCloseMultipleScreen": {
    "title": "Close Multiple Cycle"
  },
  "cycleGraphScreen": {
    "title": "Cycle Graph"
  },
  "financeScreen": {
    "title": "Finance",
    "ongoingFeatureTitle": "Jali is working on something new!",
    "ongoingFeatureSubtitle": "Thank you for using JALA App. This feature still in development. Platinum Members and Pro Cycle user can use the finance feature in the Jala Web App.",
    "openWeb": "Open Web App",
    "learnProCycle": "Learn Pro Cycle",
  },
  "simulationScreen": {
    "title": "Simulation",
    "emptyTitle": "There's no Simulation",
    "emptySubtitle": "Saved simulation\nwill be shown here.",
    "biomassHeader": "Biomass (kg)",
    "priceHeader": "Total Price",
    "createSimulation": "Create Simulation",
    "listTitle": "Simulation List",
    "totalSeed": "Total seed",
    "survivalRate": "Survival rate",
    "biomassEstimation": "Biomass estimation",
    "edit": "Edit",
    "delete": "Delete",
    "name": "Simulation Name",
    "wide": "Pond Area (m²)",
    "date": "Date",
    "seed": "Total Seed",
    "periode": "Harvest Period",
    "maxBiomass": "Max Biomass (kg/m²)",
    "survival": "Target Survival Rate (%)",
    "size100": "Size at days 100 (tail/kg)",
    "feedPrice": "Feed Price Per-kg",
    "currency": "Currency",
    "addPartial": "Add Partial Plan",
    "partialPlan": "Partial Plan",
    "age": "Age (days)",
    "percent": "Percent",
    "addPlan": "Add Plan",
    "cancel": "Cancel",
    "show": "Show",
    "inputTitle": "Input Simulation Data",
    "inputAge": "Input age",
    "inputPercent": "Input percentage",
    "SimulationTabTitle": "Simulation Results",
    "HarvestPriceDisclaimer": "Total harvest price still empty, because price table not yet filled.",
    "inputPrice": "Input Price Table",
    "priceSimulation": "Shrimp Price Simulation",
    "locationDisclaimer": "Choose the location to get your harvest price simulation.",
    "location": "Location",
    "chooseLocation": "Choose location filter",
    "inputPriceTag": "Input price",
    "FeedPerfectData": "Feed at 100% SR (kg)",
    "FeedChartTitle": "Feed (kg)",
    "BiomassChartTitle": "Total Biomass Alive",
    "BiomassChartLegend": "Total Biomass Alive (ton)",
    "BiomassMaxPerArea": "Biomass Max per-area (ton)",
    "BiomassPerfectData": "Total Biomass at 100% SR (ton)",
    "FeedTabTitle": "Feed Output Projection",
    "FeedPriceTotal": "Total Feed Price",
    "seeFeedTab": "Show Feed Table",
    "deleteTitle": "Delete Simulation?",
    "deleteSubtitle": "Are you sure to delete {{simulation}}?",
    "namePlaceholder": "Simulation {{date}}",
    "widePlaceholder": "1,000m²",
    "seedPlaceholder": "100,000 tail",
    "periodePlaceholder": "120 days",
    "biomassPlaceholder": "1,2 kg/m²",
    "survialPlaceholder": "100%",
    "sizePlaceholder": "45",
    "feedPlaceholder": "Rp 15000",
    "currencyPlaceholder": "Indonesia",
    "showPrice": "See Price",
    "save": "Save Simulation",
    "searchSimulation": "Search Simulation List...",
    "showBiomasstable": "Show Biomass Table",
    "biomasAxisY": "Total Biomass (ton)",
    "axisX": "Days",
    "feedAxisY": "Feed Consumption (kg)",
    "TotalHarvest": "Total Harvest",
    "quantityShort": "Tails",
    "HarvestTab": "Harvest",
    "FeedTab": "Feed",
    "BiomassTab": "Biomass",
    "DateDOCHeader": "Date (DoC)",
    "Size": "Size",
    "TotalBiomass": "Total biomass (kg)",
  },
  "customFRScreen": {
    "title": "Edit FR Table",
    "create": "Create your FR Table",
    "here": "here"
  },
  "parameterListScreen": {
    "title": "Parameter List",
    "info": "You can only choose 3 parameters to display on the mobile app. To view all of the record, access it through the web app (https://app.jala.tech)",
    "chemical": "Chemical",
    "plankton": "Plankton",
    "microbio": "Microbiology"
  },
  "cycleToDoScreen": {
    "title": "To Do",
    "empty": "There's no activity yet",
    "emptyFarm": "This feature is unavailable because you don't have farm",
    "emptyPond": "This feature is unavailable because you don't have pond",
    "emptyCycle": "This feature is unavailable because you don't have active cyle",
    "infoTitle": "To Do Feature",
    "info": "Manage your cultivation activities and data inputs on feed, water quality, treatments, and other activities easily with the to-do feature. Faster and easier input to get more accurate prediction results.",
    "feeding": "Feeding",
    "measuring": "Water quality check",
    "treatment": "Pond treatment",
    "feeding_tray_control": "Feeding tray check",
    "sampling": "Sampling check",
    "mortality": "Mortality record",
    "harvest_partial": "Partial harvest",
    "harvest_total": "Total harvest",
    "inputDoc": "Input DoC range",
    "until": "until",
    "addActivity": "Add Activity",
    "addActivityNote": "Are you sure you want to add {{activity}} to your daily activity?",
    "incomplete": "Incomplete",
    "missed": "Missed",
    "complete": "Complete",
    "closed": "Cycle closed",
    "seeOthers": "See Other Activities",
    "seeLess": "See Less",
    "changeActivityStatus": "Change Activity Status",
    "setting": "To Do Settings",
    "changeStatus": "Change status",
    "saveSetting": "Save Settings",
    "morningRecord": "Morning check",
    "eveningRecord": "Evening check",
    "settingWarning": "The selected to do will appear on your to do page.",
    "settingTitle": "Add To Do",
    "rangeDoc": "DoC range",
    "rangeDocMax": "DoC range not more than 130",
    "rangeDocFrom": "From DoC",
    "rangeDocTo": "To DoC",
    "lessThan130": "{{field}} range should be less than 130",
    "emptySearchTitle": "Pond not found",
    "emptySearchSubtitle": "Use different search keywords to find the pond you're looking for",
    "functionDescription": "Function Description",
    "infoDescription": "Read daily task guide",
    "refreshDescription": "Refresh the daily task data",
    "searchDescription": "Pond name search field",
    "incompleteDescription": "Daily tasks are incomplete",
    "completeDescription": "Daily tasks are complete",
    "hiddenDescription": "Hiding undone task",
    "changeStatusDescription": "Change daily task status if there is an error",
    "settingDescription": "Add or remove the daily task"
  },
  "chemicalParameterScreen": {
    "emptyHistoryParameterTitle": "Complete Your Data",
    "emptyHistoryParameterMessage": "To get the chemical predictions, please complete your feed data and physical parameters record (pH, salinty, temperature, and DO).",
    "completeData": "Complete Data",
    "emptyMessageNewUser": "This feature cannot be access because you do not have an active cycle yet.",
    "gotoProTitle": "Get chemical prediction calculations by simply recording feed and physical water quality (pH, salinity, temperature, and DO).",
    "gotoProMessage": "JALA helps you predict chemical data based on the data you record in the app.",
    "buttonGotoPro": "Upgrade Now",
    "lowAccuracyTitle": "Prediction Accuracy Not Optimal",
    "lowAccuracyMessage": "Complete recording of feed data and\nphysical parameters (pH, salinity, temperature,\nDO).",
    "latestUpdateText": "Latest data {{date}}",
    "parameter": "Parameters",
    "actualValueToday": "Actual (DoC {{age}})",
    "estimateValueToday": "Estimate (DoC {{age}})",
    "estimateValueDoC": "Latest estimation\n(DoC {{age}})",
    "week": "7 Days",
    "month": "30 Days",
    "cycle": "1 Cycle",
    "lowAccuracyPredictionMessage": "Complete recording of feed data and physical parameters (pH, salinity, temperature, DO) ",
    "emptyPredictionMessage": "Cannot generate the predictions. Please input the recording of <b>feed data</b> and <b>physical parameters</b> to display the prediction. ",
    "showDetail": "Show details",
    "alkalinity": "Alkalinity",
    "hardness": "Hardness",
    "otherParameter": "Other Parameters",
    "carbonate": "CO³",
    "bicarbonate": "HCO³",
    "calcium": "Ca",
    "magnesium": "Mg",
    "ammonia": "Ammonia",
    "nitrite": "Nitrite",
    "nitrate": "Nitrate",
    "tom": "TOM",
    "total": "Total",
    "data": "Data",
    "readDescription": "Read Explanation",
    "sendFeedback": "Give Feedback",
    "beta": "Beta",
    "alertBeta": "This prediction is still on testing (beta)\n<description> or <feedback>.",
    "buttonBetaCard": "Apply to Become a Beta Tester",
    "titleBetaCard": "Get chemical prediction calculations by simply recording feed data and physical water quality (pH, salinity, temperature and DO).",
    "messageBetaCard": "This feature is still in the testing phase and only has limited access. If you're interested in giving it a shot and providing feedback, please submit yourself via the button below",
    "titleBetaSheet": "Chemical Parameter Prediction",
    "content1BetaSheet": "With this feature you can predict water quality data, especially chemical parameters, and you can use it as an alternative medium to determine the right treatment to always maintain the stability of the water quality in the pool.",
    "content2BetaSheet": "This predictions can be displayed when there is data recording in the application which includes cumulative feed data and water quality physical parameters (pH, salinity, temperature, and DO).",
    "content3BetaSheet": "The predictions are made by an artificial intelligence engine that studies water quality, climate, and feed input conditions from various data on shrimp aquaculture ponds in Indonesia.",
    "subtitle1BetaSheet": "What parameters can be predicted?",
    "subtitle2BetaSheet": "How does this feature work?",
    "subtitle3BetaSheet": "How to generate the predictions?",
    "note1BetaSheet": "We realize that this calculation still needs improvement, so your feedback means a lot to us.",
    "note2BetaSheet": "<b>Note:</b> This prediction does not consider other factors such as weather, water color, siphon, and others.",
    "emptyDataTitle": "Predictions Value Not Displayed",
    "emptyDataMessage": "Chemical predictions will be displayed if feed recording data and physical parameters (pH, salinity, temperature, DO) are available for at least the last 3 days",
    "emptyCycle": "This feature cannot be accessed because you do not have an active cycle yet."
  },
  "gotoJalaProScreen": {
    "buttonText": "JALA Apps Pro",
    "title": "Getting Proffesional with\n",
    "description": "Manage cultivation data with more complete features to become comprehensive and useful insights.",
    "benefitTitle1": "Input Excel",
    "benefitDesc1": "collective cultivation data in a more familiar format.",
    "benefitTitle2": "Financial Management",
    "benefitDesc2": "Manage and monitor pond income and expenditure.",
    "benefitTitle3": "Pond Stock",
    "benefitDesc3": "Manage and monitor the condition of your pond stock.",
    "benefitTitle4": "Cultivation Report",
    "benefitDesc4": "Generate automatic cultivation reports with complete analysis.",
    "benefitTitle5": "Chemical Predictions",
    "benefitDesc5": "Get predictions of chemical data by leveraging AI technology.",
    "readMore": "Read more at ",
    "urlJalaPro": "https://jala.tech/pro",
    "upgradeNow": "Upgrade Now",
    "upgrade": "Upgrade",
  }
}
